import type { TAnalyticsContext } from '../types/analytics-context.types';

export const omitUndefinedValues = (context: TAnalyticsContext): TAnalyticsContext =>
  Object.fromEntries(Object.entries(context).filter(([, value]) => value !== undefined));
